import { useEffect } from 'react';
import {
  API_ERROR_EVENT,
  CREATE_TICKET_API_URL
} from '@brahma/utils/network/constants';
import type { ApiErrorEventDetail } from '@brahma/utils/network/type';
import useMutation from '../use-mutation';
import { logger, POST } from '@brahma/utils';
import {
  type IBFFResponse,
  type TicketRequest,
  type TicketResponse
} from '@dfg/brahma-types';

export const useAutomatedTicketCreation = () => {
  const { mutateAsync: createTicket } = useMutation<
    IBFFResponse<TicketResponse>,
    TicketRequest
  >(
    {
      url: CREATE_TICKET_API_URL,
      options: {
        method: POST
      }
    },
    0,
    false
  );

  useEffect(() => {
    const handleApiError = (event: CustomEvent<ApiErrorEventDetail>) => {
      void createTicket({
        screenshot: event.detail.screenshot,
        traceId: event.detail.traceId,
        documentId: null,
        description:
          event?.detail?.error?.dfgMessage ??
          event?.detail?.error?.message ??
          '',
        error:
          event?.detail?.error?.dfgMessage ??
          event?.detail?.error?.message ??
          '',
        status:
          event?.detail?.error?.httpStatusCode ??
          event?.detail?.error?.statusCode ??
          '',
        url: event.detail.pageURL,
        uniqueErrorId: `${event.detail.url.split('?')[0]}-${
          event.detail.error?.httpStatusCode ?? event.detail.error?.statusCode
        }`
      }).catch((error) => {
        logger.error({
          message: 'Error creating ticket',
          data: error.message ?? error.cause
        });
      });
    };

    window.addEventListener(API_ERROR_EVENT, handleApiError as EventListener);

    return () => {
      window.removeEventListener(
        API_ERROR_EVENT,
        handleApiError as EventListener
      );
    };
  }, []);

  return {};
};

export default useAutomatedTicketCreation;
